export const info = {
  name: 'Let\'s Code',
}



// WEBPACK FOOTER //
// ./src/info.js